import SubTabs from "@/components/SubTabs";

/**
 * Fælles side-layout for fane-sider (Hub, Performance, Forecast, Score …).
 *
 * Ejer ÉT sted afstanden mellem undermenu og indhold, så ingen fane selv kan
 * bestemme sin spacing → faner kan aldrig divergere visuelt. Vil man justere
 * afstanden for ALLE sider, rettes kun her (SUBMENU_GAP nedenfor).
 *
 * Props:
 *  - submenu: { tabs:[{key/id,label}], value, onChange }  (valgfri — udelades hvis
 *    siden ingen undermenu har; så renderes kun indholdet)
 *  - children: sidens indhold
 *  - className: ekstra klasser på yderste wrapper (valgfri)
 */

// Afstand fra undermenuen ned til indholdet — ÉT sted for hele appen.
const SUBMENU_GAP = "mb-6";

export default function TabPageLayout({ submenu, children, className = "" }) {
  return (
    <div className={className}>
      {submenu && submenu.tabs?.length > 0 && (
        <div className={SUBMENU_GAP}>
          <SubTabs tabs={submenu.tabs} value={submenu.value} onChange={submenu.onChange} />
        </div>
      )}
      {children}
    </div>
  );
}
